import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Layout from '../../components/Layout'
import Header from '../../components/shared/Header';
import './PickingLocations.scss';
import Search from '../../components/shared/Search';
import Modal from '../../components/shared/Modal';
import { loadingActions, filterActions } from '../../redux/actions';
import CustomSelect from '../../components/shared/CustomSelect';
import ModalLocation from './ModalLocation';
import RowLocation from './RowLocation';
import storesAPI from '../../api/storesAPI';
import { ROLES_PERFILES } from '../../config'
import useUpdateEffect from '../../hooks/useUpdateEffect';
import locationsAPI from '../../api/locationsAPI';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import AnotherSessionModal from '../../components/shared/AnotherSessionModal';
import { sessionError } from '../../utils/sessionError';

const defaultDivisionOpt = [
  {
    label: 'División',
    options: [],
  },
]
const defaultDepartmentOpt = [
  {
    label: 'Departamento',
    options: [],
  },
]
const defaultLineOpt = [
  {
    label: 'Linea',
    options: [],
  },
]
const defaultBrandOpt = [
  {
    label: 'Marca',
    options: [],
  },
]
const defaultStoreOpt = [
  {
    label: 'Sucursal',
    options: [],
  },
]

const CustomSymbol = ({ color = '#7C3F88', margin, symbol = '>' }) => {
  return (
    <div style={{ color, margin }} className='custom_greaterThan'>{symbol}</div>
  )
}

const PickingLocations = () => {
  const [textSearch, setTextSearch] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [modalDelete, setModalDelete] = useState(false)
  const [modalSession, setModalSession] = useState(false)
  const [modalErrorProfile, setModalErrorProfile] = useState(false)
  const [modalError, setModalError] = useState(false)
  const [companies, setCompanies] = useState([])
  const [filters, setFilters] = useState({
    division: null,
    departments: null,
    line: null,
    brand: null,
    store: null
  })
  const [divisionOpt, setDivisionOpt] = useState(defaultDivisionOpt)
  const [departmentOpt, setDepartmentOpt] = useState(defaultDepartmentOpt)
  const [lineOpt, setLineOpt] = useState(defaultLineOpt)
  const [brandOpt, setBrandOpt] = useState(defaultBrandOpt)
  const [storeOpt, setStoreOpt] = useState(defaultStoreOpt)
  const [selectedLocation, setSelectedLocation] = useState(null)
  const { stores, profiles } = useSelector(state => state.authReducer.user)
  const [error, setError] = useState({
    locationName: '',
    brand: '',
  })
  const dispatch = useDispatch()
  const history = useHistory()

  // console.log('user :', user)
  console.log('{ stores, profiles } :', { stores, profiles });

  useEffect(() => {
    console.log('REMOUNTING COMPONENT')
  })

  useUpdateEffect(() => {
    console.log('ON UPDATE filters')
    console.log(filters)
    if (filters.store) fetchLocations()
    // eslint-disable-next-line
  }, [filters])

  useUpdateEffect(() => {
    setFilters({ ...filters, departments: null })
    if (filters.division) fetchDepartments()
    // eslint-disable-next-line
  }, [filters.division])

  useUpdateEffect(() => {
    setFilters({ ...filters, line: null });
    if (filters.departments) fetchLines()
    // eslint-disable-next-line
  }, [filters.departments])

  useUpdateEffect(() => {
    console.log('ON UPDATE STOREOPT')
    setFilters({ ...filters, store: storeOpt[0]['options'][0] })
    // eslint-disable-next-line
  }, [storeOpt])

  useEffect(() => {
    console.log('ON MOUNT COMPONENT')
    // fetchLocations()
    fetchDivisions();
    fetchBrands();
    if (!Array.isArray(profiles)) setModalErrorProfile(true)
      else if (profiles.some(p => p.profilecode === ROLES_PERFILES.PROFILES.ADMCODE)) fetchStores()
      else if (stores.length > 0) setStoreOpt([
        {
          label: 'Sucursal',
          options: stores.map(s => ({ value: s.storeId, label: s.storeName }))
        },
      ])
      // CLEAN FILTERS FROM ALL OTHER TABS
    dispatch(filterActions.cleanAll());
    // eslint-disable-next-line
  }, [])

  useUpdateEffect(() => {
    setError({
      locationName: '',
      brand: '',
    })
  }, [showModal])

  const fetchLocations = async () => {
    try {
      dispatch(loadingActions.setLoading(true))
      const data = await locationsAPI.getLocations(filters)
      setCompanies(data)
      dispatch(loadingActions.setLoading(false))
    } catch (e) {
      console.log(e)
      dispatch(loadingActions.setLoading(false))
      if (sessionError(e)) {
        setModalSession(true)
      } else {
        setModalError(true)
      }
    }
  }

  const fetchDivisions = async () => {
    try {
      const data = await locationsAPI.getDivisions()
      const dataToSet = data.map(d => ({ ...d, value: d.cod_division, label: d.desc_division }))
      setDivisionOpt([
        {
          label: 'División',
          options: dataToSet
        },
      ])
    } catch (e) {
      console.log(e)
      if (sessionError(e)) {
        setModalSession(true)
      } else {
        setModalError(true)
      }
    }
  }

  const fetchDepartments = async () => {
    try {
      const data = await locationsAPI.getDepartments({ cod_division: filters.division?.value })
      const dataToSet = data.map(d => ({ ...d, value: d.cod_depto, label: d.desc_depto }))
      setDepartmentOpt([
        {
          label: 'Departamento',
          options: dataToSet
        },
      ])
    } catch (e) {
      console.log(e)
      if (sessionError(e)) {
        setModalSession(true)
      } else {
        setModalError(true)
      }
    }
  }

  const fetchLines = async () => {
    try {
      const data = await locationsAPI.getLines({ cod_depto: filters.departments?.value })
      const dataToSet = data.map(d => ({ ...d, value: d.cod_linea, label: d.desc_linea }))
      setLineOpt([
        {
          label: 'Linea',
          options: dataToSet
        },
      ])
    } catch (e) {
      console.log(e)
      if (sessionError(e)) {
        setModalSession(true)
      } else {
        setModalError(true)
      }
    }
  }

  const fetchBrands = async () => {
    try {
      const data = await locationsAPI.getBrands()
      const dataToSet = data.map(d => ({ ...d, value: d.cod_marca_odbms, label: d.desc_marca }))
      setBrandOpt([
        {
          label: 'Marcas',
          options: dataToSet
        },
      ])
    } catch (e) {
      console.log(e)
      if (sessionError(e)) {
        setModalSession(true)
      } else {
        setModalError(true)
      }
    }
  }

  const fetchStores = async () => {
    try {
      const stores = await storesAPI.getStores();
      console.log(stores, 'stores')
      const formatStores = stores.map(s => ({ ...s, value: s.id, label: s.name }))
      setStoreOpt([{
        label: 'Sucursal',
        options: formatStores,
      }])
    } catch (e) {
      console.log(e)
      if (sessionError(e)) {
        setModalSession(true)
      } else {
        setModalError(true)
      }
    }
  }

  const addItem = async ({ brand, department, division, line, locationName }) => {
    try {
      dispatch(loadingActions.setLoading(true))
      // console.log('ITEM TO ADDDDD',item);
      const dataToCreate = {
        name: locationName,
        storeId: filters.store?.value,
        divisionId: division?.value,
        departmentId: department?.value,
        lineId: line?.value || null,
        brandId: brand?.value || null,
      }
      await locationsAPI.createLocation(dataToCreate)
      await fetchLocations();
      dispatch(loadingActions.setLoading(false))
      setShowModal(false)
      setSelectedLocation(null)
    } catch (e) {
      console.log(e);
      console.log(e?.response?.status)
      console.log(e?.response?.data)
      if (e?.response?.data?.repeatedCombo && e?.response?.data?.repeatedName) setError({ locationName: 'Esta ubicación ya existe.', brand: 'Esta combinación ya tiene ubicación.' })
      else if (e?.response?.data?.repeatedCombo) setError({ ...error, brand: 'Esta combinación ya tiene ubicación.' })
      else if (e?.response?.data?.repeatedName) setError({ ...error, locationName: 'Esta ubicación ya existe.' })
      dispatch(loadingActions.setLoading(false))
      if (sessionError(e)) {
        setModalSession(true)
      } 
    }
  }

  const updateItem = async ({ brand, department, division, line, locationName }) => {
    try {
      dispatch(loadingActions.setLoading(true))
      const dataToCreate = {
        name: locationName,
        storeId: filters.store?.value,
        divisionId: division?.value,
        departmentId: department?.value,
        lineId: line?.value || null,
        brandId: brand?.value || null,
      }
      await locationsAPI.updateLocation(dataToCreate, selectedLocation.id)
      await fetchLocations();
      dispatch(loadingActions.setLoading(false))
      setShowModal(false)
      setSelectedLocation(null)
    } catch (e) {
      console.log(e);
      console.log(e?.response?.status)
      console.log(e?.response?.data)
      if (e?.response?.data?.repeatedCombo) setError({ ...error, brand: 'Esta combinación ya tiene ubicación.' })
      if (e?.response?.data?.repeatedName) setError({ ...error, locationName: 'Esta combinación ya tiene ubicación.' })
      dispatch(loadingActions.setLoading(false))
      if (sessionError(e)) {
        setModalSession(true)
      } 
    }
  }

  const deleteItem = async () => {
    try {
      dispatch(loadingActions.setLoading(true))
      await locationsAPI.deleteLocation(selectedLocation.id)
      await fetchLocations();
      dispatch(loadingActions.setLoading(false))
      setModalDelete(false)
      setSelectedLocation(null)
    } catch (e) {
      dispatch(loadingActions.setLoading(false))
      if (sessionError(e)) {
        setModalSession(true)
      } 
    }
  }

  const including = a => {
    return a.toUpperCase().includes(textSearch.toUpperCase())
  }

  const renderData = () => {
    const filteredData = companies.filter(location => including(location.name) || including(location.divisionName))
    return filteredData.map(location => (
      <RowLocation
        key={location.id}
        division={location.divisionName}
        department={location.departmentName}
        line={location.lineName}
        brand={location.brandName}
        locationName={location.name}
        onClickEdit={() => {
          setSelectedLocation(location)
          setShowModal(true)
        }}
        onClickDelete={() => {
          setSelectedLocation(location)
          setModalDelete(true)
        }}
      />
    ))
  }

  return (
    <Layout>
       <AnotherSessionModal isOpen={modalSession} onClose={() => setModalSession(false)} />
      {showModal && (
        <ModalLocation
          visible={showModal}
          onClose={() => {
            setShowModal(false);
            setSelectedLocation(null);
          }}
          selectedLocation={selectedLocation}
          store={filters.store}
          onClick1={() => {
            setShowModal(false)
            setSelectedLocation(null)
          }}
          onClick2={data => {
            selectedLocation ? updateItem(data) : addItem(data)
          }}
          error={error}
          changeError={() => setError({ locationName: '', brand: '' })}
        />
      )
      }
      {modalDelete && (
        <Modal
          visible={modalDelete}
          onClose={() => {
            setModalDelete(false);
            setSelectedLocation(null);
          }}
          title='¿Deseas eliminar esta ubicación?'
          color='var(--ripley-salmon)'
          btn1={{
            text: 'Cancelar',
            type: 'secondary',
            onClick: () => {
              setModalDelete(false)
              setSelectedLocation(null)
            }
          }}
          btn2={{
            text: 'Eliminar',
            type: 'primary',
            onClick: () => {
              deleteItem()
            }
          }}
        >
          <div className='modal-delete-company'>
            <p>Vas a borrar</p>
            <p className='modal-delete-company-name'>{selectedLocation.name}</p>
            {/* <p className='modal-delete-company-ruc'>RUC {selectedLocation.ruc}</p> */}
          </div>
        </Modal>
      )
      }
      <Modal
        visible={modalErrorProfile}
        // onClose={() => setModalErrorProfile(false)}
        title='No se encuentra Perfil asignado'
        color='var(--ripley-salmon)'
        btn1={{
          text: 'Regresar',
          type: 'primary',
          onClick: () => history.goBack()
        }}
        // btn2={{
        //   text: 'Eliminar',
        //   type: 'primary',
        //   onClick: () => setModalErrorProfile(false)
        // }}
      >
        <div className='modal-delete-company'>
          <p>No se esta encontrando el perfil asociado a su cuenta, por favor intente cerrar sesión e ingresar nuevamente</p>
          {/* <p>Si el error persiste comuniquese con el area de </p> */}
        </div>
      </Modal>
        )
      <Modal
        visible={modalError}
        onClose={() => { }}
        title='No hay conexión'
        titleImage={require('../../../assets/icons/ic_disconnected.svg')}
        color='var(--ripley-salmon)'
        btn1={{
          text: 'Volver',
          type: 'secondary',
          onClick: () => {
            setModalError(false)
          }
        }}
        btn2={{
          text: 'Reintentar',
          type: 'primary',
          onClick: () => {
            setModalError(false)
            fetchLocations()
          }
        }}
      >
        <div className='modal-error'>
          <p>Revisa tu conexión a internet e inténtalo de nuevo</p>
        </div>
      </Modal>
      <div className='picking-location-container'>
        <div className='picking-location-container-head'>
          <Header
            title='Picking'
            subtitle='Ubicación de ítems'
            onClickBtn1={() => setShowModal(true)}
            btnTitle1='Agregar'
          />
          <div className='picking-location-container-filters'>
            <div className='picking-location-container-select store'>
              <CustomSelect
                multi={false}
                allLabel={false}
                value={filters.store}
                onChange={(e, a) => setFilters({ ...filters, store: e })}
                placeholder='Sucursal'
                options={storeOpt}
              />
            </div>
            <CustomSymbol />
            <div className='picking-location-container-select division'>
              <CustomSelect
                value={filters.division}
                allLabel={false}
                onChange={(e, a) => setFilters({ ...filters, division: e })}
                placeholder='División'
                options={divisionOpt}
              />
            </div>
            <CustomSymbol />
            <div className='picking-location-container-select department'>
              <CustomSelect
                value={filters.departments}
                disabled={!filters.division}
                allLabel={false}
                onChange={(e) => setFilters({ ...filters, departments: e })}
                placeholder='Departamento'
                options={departmentOpt}
              />
            </div>
            <CustomSymbol />
            <div className='picking-location-container-select line'>
              <CustomSelect
                value={filters.line}
                disabled={!filters.departments}
                allLabel={false}
                onChange={(e) => setFilters({ ...filters, line: e })}
                placeholder='Linea'
                options={lineOpt}
              />
            </div>
            <CustomSymbol symbol='-' />
            <div className='picking-location-container-select brand'>
              <CustomSelect
                value={filters.brand}
                allLabel={false}
                onChange={(e) => setFilters({ ...filters, brand: e })}
                placeholder='Marca'
                options={brandOpt}
              />
            </div>
            <div className='location-search-container'>
              <Search
                placeholder='Buscar'
                value={textSearch}
                onChange={text => setTextSearch(text)}
              />
            </div>
          </div>
        </div>
        <div className='picking-location-container-list'>
          {filters.store && renderData()}
        </div>
      </div>
    </Layout>
  )
}

export default PickingLocations
